export const formatTemplateDate = (value) => {
  if (!value) {
    return 'Just now';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const normalizeTemplate = (data, fallbackId) => {
  if (!data) {
    return null;
  }

  const outputSchema = data.outputSchema;
  let parsedOutputSchema = outputSchema;

  if (typeof outputSchema === 'string') {
    try {
      parsedOutputSchema = JSON.parse(outputSchema);
    } catch (_error) {
      parsedOutputSchema = outputSchema;
    }
  }

  return {
    id: data.templateId || data.id || fallbackId || '',
    name: data.name || '',
    version: data.version ?? '',
    content: data.content || '',
    outputSchema: parsedOutputSchema,
    rawOutputSchema: outputSchema,
    isActive: Boolean(data.isActive),
    promptKey: data.promptKey || null,
    category: data.category || 'custom',
    createdAt: data.createDate || null,
    updatedAt: data.changeDate || null,
    formattedCreatedAt: formatTemplateDate(data.createDate),
    formattedUpdatedAt: formatTemplateDate(data.changeDate),
  };
};

export const toOutputSchemaString = (value) => {
  if (!value) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    console.warn('Failed to stringify output schema', error);
    return '';
  }
};

